<template>
  <v-app>
    <v-main v-if="configIsLoaded" style="background-color: #f1f1f1;">
      <router-view />
    </v-main>
    <gk-progress tag="api" />
  </v-app>
</template>

<script>
import gkProgress from './components/gk-progress.vue';
import { getCookieAlertVisible, hideCookieAlert } from './shared/storage-cookie-alert';
import { ACTION_GET_CONFIGURATION } from './store/const-actions';

export default {
  name: 'app',

  components: { gkProgress },

  data: () => ({
    isCookieAlertVisible: getCookieAlertVisible(),
    configIsLoaded: false
  }),

  created () {
    const vm = this;
    const getConfig = async () => {
      await vm.$store.dispatch(ACTION_GET_CONFIGURATION, { tag: 'api' });
      vm.configIsLoaded = true;
    };
    getConfig();
  },

  methods: {
    onCookieAlertClick () {
      hideCookieAlert();
      this.isCookieAlertVisible = false;
    }
  }
};
</script>

<style lang="scss">
@import url("../src/assets/scss/main.scss");
@import url("../src/assets/scss/style.scss");
</style>
